const state = {
  selectedTab: '',
  selectedSocietyId: null,
};

const mutations = {
  setSelectedTab(state, data) {
    state.selectedTab = data.selectedTab;
    state.selectedSocietyId = data.societyId || null;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
